import React, { useEffect } from 'react';
import { Switch, useHistory } from 'react-router-dom';
import { Navigation } from '@/pages/user-dashboard/components/index';
import { Route, routes } from '@/app/routing/index';
import DecedentProfile from '@/pages/decedent-profile/index';
import TaskList from '@/pages/task-list/index';
import EntryLists from '@/pages/entry-lists/index';
import About from '@/pages/about/index';
import GeneralNotes from '@/pages/general-notes/index';
import FinInstitutions from '@/pages/fin-institutions/index';
import FinancialDetails from '@/pages/financial-details/index';
import AccountSettings from '@/pages/account-settings/index';
import {
  useCurrentDecedentId,
  useCurrentDecedentLoading,
  usePassedBasicForm,
} from '@/app/providers/DecedentProvider';
import Preloader from '@/common/components/Preloader';
import ErrorBoundary from '@/common/components/ErrorBoundary';

const UserDashboard = () => {
  const history = useHistory();
  const currentDecedentId = useCurrentDecedentId();
  const isCurrentDecedentLoading = useCurrentDecedentLoading();
  const passedBasicForm = usePassedBasicForm();

  useEffect(() => {
    if (!currentDecedentId || isCurrentDecedentLoading) {
      return;
    }

    if (passedBasicForm === false) {
      history.push(routes.decedentInitiation);
    }
  }, [currentDecedentId, history, isCurrentDecedentLoading, passedBasicForm]);

  if (!currentDecedentId || isCurrentDecedentLoading) {
    return <Preloader />;
  }

  return (
    <main className="dashboardContainer">
      <Navigation />
      <section className="dashboardContainerContent">
        <ErrorBoundary>
          <Switch>
            <Route
              path={routes.dashboard.accountSettings}
              component={AccountSettings}
              auth
            />
            <Route
              path={`${routes.dashboard.profile}/:tab`}
              component={DecedentProfile}
              auth
            />
            <Route
              path={`${routes.dashboard.taskList}/:tab`}
              component={TaskList}
              auth
            />
            <Route
              path={routes.dashboard.entryLists}
              component={EntryLists}
              auth
            />
            <Route path={routes.dashboard.about} component={About} auth />
            <Route path={routes.dashboard.generalNotes} component={GeneralNotes} auth />
            <Route
              path={routes.dashboard.finInstitutionDetails}
              component={FinancialDetails}
              auth
            />
            <Route
              path={routes.dashboard.finInstitutions}
              component={FinInstitutions}
              auth
            />
          </Switch>
        </ErrorBoundary>
      </section>
    </main>
  );
};

export default UserDashboard;
